import React, { useEffect, useRef, useState } from "react";
import {
  Modal,
  Button,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextareaAutosize,
} from "@mui/material";
import stateList from "../../../data/states.json";

const EditStudents = ({ open, onClose, rowData, onUpdate }) => {
  const [editData, setEditData] = useState(rowData);
  const [cityList, setCityList] = useState([]);
  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditData((prev) => ({ ...prev, [name]: value }));

    if (name === "state") {
      const selectedState = stateList.states.find(
        (s) => s.state_code === value
      );
      setCityList(selectedState ? selectedState.cities : []);
      setEditData((prev) => ({ ...prev, city: "" })); // Reset city selection
    }
  };

  const isPhoneInitiallySet = useRef(!!rowData?.phone);

  useEffect(() => {
    setEditData(rowData || {});

    // If rowData has a state, set the corresponding city list
    if (rowData?.state) {
      const selectedState = stateList.states.find(
        (s) => s.state_code === rowData.state
      );
      setCityList(selectedState ? selectedState.cities : []);
    } else {
      setCityList([]); // Reset city list if no state is selected
    }

    isPhoneInitiallySet.current = !!rowData?.phone;
  }, [rowData]);
  return (
    <Modal open={open} onClose={onClose}>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "8px",
          width: "60%",
          maxHeight: "80vh",
          overflowY: "auto",
        }}
      >
        <h2>Edit Data</h2>

        {/* <img
          src={viewImage}
          alt="Preview"
          style={{
            width: "100px",
            height: "100px",
            objectFit: "cover",
            borderRadius: "8px",
          }}
        /> */}

        <TextField
          label="Name"
          name="name"
          value={editData.name}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Parent Name"
          name="parent_name"
          value={editData.parent_name}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Email"
          name="email"
          type="email"
          value={editData.email}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />

        <TextField
          label="Phone"
          name="phone"
          type="tel"
          value={editData.phone || ""}
          onChange={handleChange}
          fullWidth
          margin="normal"
          inputProps={{ maxLength: 10 }}
          // disabled={isPhoneInitiallySet.current} // Disable only if initially set
        />

        <FormControl fullWidth margin="normal">
          <InputLabel>Class</InputLabel>
          <Select name="class" value={editData.class} onChange={handleChange}>
            {[...Array(12).keys()].map((num) => (
              <MenuItem key={num + 1} value={num + 1}>
                {num + 1}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl component="fieldset" margin="normal">
          <label>Is Deleted?</label>
          <RadioGroup
            row
            name="is_deleted"
            value={editData.is_deleted === true ? "true" : "false"}
            onChange={(event) =>
              handleChange({
                target: {
                  name: "is_deleted",
                  value: event.target.value === "true",
                },
              })
            }
          >
            <FormControlLabel value="true" control={<Radio />} label="Yes" />
            <FormControlLabel value="false" control={<Radio />} label="No" />
          </RadioGroup>
        </FormControl>

        <FormControl fullWidth margin="normal">
          <InputLabel>State</InputLabel>
          <Select name="state" value={editData.state} onChange={handleChange}>
            {stateList.states
              ?.sort((a, b) => a.name.localeCompare(b.name))
              ?.map((state) => (
                <MenuItem key={state.name} value={state.state_code}>
                  {state.name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>

        <FormControl fullWidth margin="normal">
          <InputLabel>City</InputLabel>
          <Select name="city" value={editData.city} onChange={handleChange}>
            {cityList.map((city) => (
              <MenuItem key={city} value={city}>
                {city}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {/* <TextField
          label="City"
          name="city"
          value={editData.city}
          onChange={handleChange}
          fullWidth
          margin="normal"
        /> */}
        <TextField
          label="Pincode"
          name="pincode"
          type="number"
          value={editData.pincode}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />

        {/* <TextField
          label="Parent Name"
          name="parent_name"
          value={editData.parent_name}
          onChange={handleChange}
          fullWidth
          margin="normal"
        /> */}

        {/* <div>Update School Image</div> */}
        {/* <input
          type="file"
          name="image"
          accept="image/*"
          onChange={handleFileChange}
          style={{ marginTop: "10px" }}
        />
        {selectedFile && (
          <div style={{ marginTop: "10px" }}>
            <img
              src={selectedFile}
              alt="Selected"
              style={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />
          </div>
        )} */}

        {/* Update Button */}
        <Button
          variant="contained"
          color="primary"
          onClick={() => onUpdate(editData)}
          style={{ marginTop: "20px", width: "100%" }}
        >
          Update
        </Button>

        {/* Close Button */}
        <Button
          variant="outlined"
          color="secondary"
          onClick={onClose}
          style={{ marginTop: "10px", width: "100%" }}
        >
          Cancel
        </Button>
      </div>
    </Modal>
  );
};

export default EditStudents;
